import React from 'react'

import classNames from 'classnames'
import styled from 'styled-components'

import { useBuildingContext } from '../../../../../contexts/buildingContext'
import { blue, gray, pink } from '../../../../../styles/colors'
import {
  MapPointArrow,
  MapPointContainer,
  MapPointMainCircle,
} from '../../../../common/MapViewer'

import { useManagePointsContext } from './ManagePointsContext'

export interface IMapPoint {
  id: number // Global database ID
  has_image: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper images element type
  images?: any[]
  is_active: boolean
  point_id: number // Local sub_id
  x: string
  y: string
  yaw?: number | null
  project_floor_section: number | null
}

interface IManagedMapPointProps {
  x: number
  y: number
  point: IMapPoint
  onClick?: (e: React.MouseEvent<HTMLDivElement>, point: IMapPoint) => void
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>, point: IMapPoint) => void
}

export const ManagedMapPoint = ({
  point,
  x,
  y,
  onClick,
  onMouseDown,
}: IManagedMapPointProps) => {
  const { state: buildingState } = useBuildingContext()

  const { canSelectPoints } = useManagePointsContext()

  const pointIsSelected: boolean = buildingState.floorData.selectedPoints.has(
    point.point_id,
  )
  const pointIsActive: boolean = point.is_active
  const inCurrentGroup: boolean = buildingState.floorData.groupPoints.has(
    point.point_id,
  )
  const pointHasImages: boolean = point.has_image
  const pointHasYaw: boolean = point.yaw != null
  const hexagonType: string =
    pointIsSelected || inCurrentGroup ? '\u2B22' : '\u2B21'

  return (
    <ManagedMapPointContainer
      className={`map-point mp-${point.point_id}`}
      x={x}
      y={y}
      isActive={canSelectPoints}
      onClick={e => {
        if (onClick) {
          onClick(e, point)
        }
      }}
      onMouseDown={e => {
        if (onMouseDown) {
          onMouseDown(e, point)
        }
      }}
    >
      {pointHasYaw && <MapPointArrow rotation={point.yaw!} />}
      {!pointHasImages && (
        <MapPointMainCircle
          className={classNames({
            back_pink: pointIsSelected && pointIsActive,
            back_pink_empty: !pointIsSelected && pointIsActive,
            back_gray: pointIsSelected && !pointIsActive,
            back_gray_empty: !pointIsSelected && !pointIsActive,
            back_blue: inCurrentGroup,
          })}
        />
      )}
      {pointHasImages && (
        <PointWithPicture
          className={classNames({
            back_pink: pointIsActive,
            back_gray: !pointIsActive,
            back_blue: inCurrentGroup,
          })}
        >
          {hexagonType}
        </PointWithPicture>
      )}
    </ManagedMapPointContainer>
  )
}

const ManagedMapPointContainer = styled(MapPointContainer)`
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &::selection {
    background-color: transparent;
  }

  &::-moz-selection {
    background-color: transparent;
  }
`

const PointWithPicture = styled.div`
  position: absolute;
  font-size: 55px;
  font-weight: bold;
  transform: translate(-50%, -50%);
  box-sizing: content-box;

  &.back_pink {
    color: ${pink};
  }

  &.back_gray {
    color: ${gray};
  }

  &.back_blue {
    color: ${blue};
  }
`
